import {Result} from '../../resultModel'
import {USERGROUPS_GETUSERGROUPBYUSERID, USERGROUPS_GETUSERSINGROUP, USERGROUPS_GETUSERSINGROUPLIST} from '../../endpoints'
import {RequestManager} from '../../RequestManager'
import {GetUserGroupByUserIdOutput, GetUsersByUserGroupListOutput, GetUsersByUserGroupOutput} from './models/getUserGroupModels'

export const getUsersByUserGroup = async (groupId: number) => {
  const requestManager = new RequestManager()

  var res: Result<GetUsersByUserGroupOutput[]> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetUsersByUserGroupOutput[]>>(USERGROUPS_GETUSERSINGROUP(groupId))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const getUsersByUserGroupList = async (groupIds: string) => {
  const requestManager = new RequestManager()

  var res: Result<GetUsersByUserGroupListOutput[]> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetUsersByUserGroupListOutput[]>>(USERGROUPS_GETUSERSINGROUPLIST(groupIds))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

export const getUserGroupByUserId = async (userId: number) => {
  const requestManager = new RequestManager()

  var res: Result<GetUserGroupByUserIdOutput[]> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<GetUserGroupByUserIdOutput[]>>(USERGROUPS_GETUSERGROUPBYUSERID(userId))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}